import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const AboutAreaFive = () => {
  return (
    <>
      {/* =============== About Area Five End ===============*/}
      <div className="about-area pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 mb-4 mb-lg-0"
              data-aos="fade-right"
              data-aos-delay="200"
              data-aos-duration="1500"
            >
              <div className="about-thumb-inner">
                <img className="main-img" src="assets/img/22.webp" alt="img" />
              </div>
            </div>
            <div
              className="col-lg-6"
              data-aos="fade-left"
              data-aos-delay="200"
              data-aos-duration="1500"
            >
              <div className="section-title mb-0 ps-xl-5">
                <h6 className="sub-title-sky-blue">了解我们的使命</h6>
                <h2 className="title">体验前所未有的智能</h2>
                <p className="content mb-4">
                  我们专注于为您提供创新的人工智能解决方案，定制以满足您的特定需求。无论您是寻求自动化流程、增强客户体验，还是优化资源分配，我们都能为您提供一流的技术和专业知识。
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="single-list-inner style-check style-heading style-check mb-3">
                      <li>
                        <FaCheckCircle className="sky" /> 先进的人工智能技术
                      </li>
                      <li>
                        <FaCheckCircle className="sky" /> 定制解决方案
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="single-list-inner style-check style-heading style-check mb-3">
                      <li>
                        <FaCheckCircle className="sky" /> 提升效率
                      </li>
                      <li>
                        <FaCheckCircle className="sky" /> 智能决策支持
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =============== About Area Five End ===============*/}
    </>
  );
};

export default AboutAreaFive;
